import { TabsSegmented } from '@/components/TabsSegmented';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { FEATURE_FLAGS } from '@/featureFlags';

const TABS = [
  { label: 'Plan', value: 'plan' },
  { label: 'Track', value: 'log' },
];

export function ModeSwitcher() {
  const { householdId } = useParams();

  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const date = searchParams.get('date');

  if (!FEATURE_FLAGS.mealTracking) {
    return null;
  }

  const activeTab = window.location.href.split('/').pop().split('?')[0] === TABS[0].value ? 0 : 1;

  function setActiveTab(tab) {
    navigate(`/h/${householdId}/meals/${TABS[tab].value}?date=${date}`);
  }

  return (
    <TabsSegmented
      tabs={TABS.map(tab => tab.label)}
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      sx={{ mb: 0, mt: 1 }}
      size="sm"
      fullWidth
    />
  );
}
